<template>
  <div class="login-container">
    <div class="login-form">
      <div class="login-title">
        <img src="@/assets/logo2.png" />
        <span>海深标注平台</span>
      </div>
      <ul class="login-tab">
        <li @click="activeTab = 'login'" :class="{ active: activeTab === 'login' }">登录</li>
        <li @click="activeTab = 'register'" :class="{ active: activeTab === 'register' }">注册</li>
      </ul>

      <div v-if="activeTab === 'login'">
        <form v-on:submit.prevent="login">
          <p>
            <input
              :class="{ warning: warningTab === '1' }"
              :style="{ backgroundImage: `url(${imgMobile})` }"
              v-model="data.body.mobile"
              class="input"
              type="text"
              placeholder="手机号"
              required
              maxlength="11"
            />
          </p>
          <p>
            <input
              :class="{ warning: warningTab === '2' }"
              :style="{ backgroundImage: `url(${imgPassword})` }"
              v-model="data.body.password"
              class="input"
              type="password"
              placeholder="密码"
              required
              maxlength="20"
            />
            <!-- <span class="forgot-password" @click="showResetDialog">找回密码</span> -->
          </p>
          <p>
            <button type="submit" class="login btn">登 录</button>
          </p>
        </form>
      </div>

      <div v-if="activeTab === 'register'">
        <form v-on:submit.prevent="signup">
          <p>
            <input
              :class="{ warning: warningTab === '3' }"
              :style="{ backgroundImage: `url(${imgUser})` }"
              v-model="data.body.userName"
              class="input"
              type="text"
              placeholder="用户名"
              required
              ref="regUserName"
              data-regex="^[0-9a-zA-Z\u4e00-\u9fa5]{2,20}$"
              data-index="3"
            />
            <span v-if="warningTab === '3'">* 2~20个字符，字母、汉字或数字均可</span>
          </p>
          <p>
            <input
              :class="{ warning: warningTab === '4' }"
              :style="{ backgroundImage: `url(${imgMobile})` }"
              v-model="data.body.mobile"
              class="input"
              type="text"
              placeholder="11位手机号"
              required
              ref="regMobile"
              data-regex="^[1][0-9]{10}$"
              data-index="4"
              maxlength="11"
            />
            <span v-if="warningTab === '4'">* 请输入正确的手机号码</span>
          </p>
          <!-- 验证码输入框 -->
          <p class="verification-code-container">
            <input
              :class="{ warning: warningTab === '5' }"
              :style="{ backgroundImage: `url(${imgCode})` }"
              v-model="data.body.verificationCode"
              class="input verification-code-input"
              type="text"
              placeholder="请输入6位验证码"
              required
              ref="regVerificationCode"
              data-regex="^[0-9]{6}$"
              data-index="5"
              maxlength="6"
            />
            <el-button
              class="send-code-btn"
              :disabled="sendCodeDisabled"
              @click="sendVerificationCode"
              type="primary"
              size="small"
            >
              {{ sendCodeText }}
            </el-button>
            <span v-if="warningTab === '5'" class="verification-code-warning">* 请输入6位数字验证码</span>
          </p>
          <p>
            <input
              :class="{ warning: warningTab === '7' }"
              :style="{ backgroundImage: `url(${imgPassword})` }"
              v-model="data.body.password"
              class="input"
              type="password"
              placeholder="6-20位密码，区分大小写"
              required
              ref="regPwd"
              data-regex="^[0-9a-zA-Z]{6,20}$"
              data-index="7"
            />
            <span v-if="warningTab === '7'">* 6~20个字符，字母或数字均可</span>
          </p>
          <p>
            <input
              :class="{ warning: warningTab === '8' }"
              :style="{ backgroundImage: `url(${imgConfirm})` }"
              v-model="data.body.confirmpwd"
              class="input"
              type="password"
              placeholder="确认密码"
              data-index="8"
            />
            <span v-if="warningTab === '8'">* 两次密码输入不一致，请重新输入</span>
          </p>
          <p>
            <button type="submit" class="register btn">注 册</button>
          </p>
        </form>
      </div>
    </div>

    <!-- 找回密码对话框 -->
    <el-dialog
      title="找回密码"
      :visible.sync="resetDialogVisible"
      width="400px"
      :close-on-click-modal="false"
      @close="resetDialogClose"
    >
      <form @submit.prevent="submitResetPassword">
        <p>
          <input
            :class="{ warning: resetWarningTab === '1' }"
            :style="{ backgroundImage: `url(${imgMobile})` }"
            v-model="resetData.mobile"
            class="input"
            type="text"
            placeholder="11位手机号"
            required
            ref="resetMobile"
            data-regex="^[1][0-9]{10}$"
            data-index="1"
            maxlength="11"
          />
          <span v-if="resetWarningTab === '1'">* 请输入正确的手机号码</span>
        </p>

        <p class="verification-code-container">
          <input
            :class="{ warning: resetWarningTab === '2' }"
            :style="{ backgroundImage: `url(${imgCode})` }"
            v-model="resetData.authCode"
            class="input verification-code-input"
            type="text"
            placeholder="请输入6位验证码"
            required
            ref="resetAuthCode"
            data-regex="^[0-9]{6}$"
            data-index="2"
            maxlength="6"
          />
          <el-button
            class="send-code-btn"
            :disabled="resetSendCodeDisabled"
            @click="sendResetVerificationCode"
            type="primary"
            size="small"
          >
            {{ resetSendCodeText }}
          </el-button>
          <span v-if="resetWarningTab === '2'" class="verification-code-warning">* 请输入6位数字验证码</span>
        </p>

        <p>
          <input
            :class="{ warning: resetWarningTab === '3' }"
            :style="{ backgroundImage: `url(${imgPassword})` }"
            v-model="resetData.password"
            class="input"
            type="password"
            placeholder="6-20位密码，区分大小写"
            required
            ref="resetPassword"
            data-regex="^[0-9a-zA-Z]{6,20}$"
            data-index="3"
            maxlength="20"
          />
          <span v-if="resetWarningTab === '3'">* 6~20个字符，字母或数字均可</span>
        </p>

        <p>
          <input
            :class="{ warning: resetWarningTab === '4' }"
            :style="{ backgroundImage: `url(${imgConfirm})` }"
            v-model="resetData.confirmPassword"
            class="input"
            type="password"
            placeholder="确认密码"
            data-index="4"
            maxlength="20"
          />
          <span v-if="resetWarningTab === '4'">* 两次密码输入不一致，请重新输入</span>
        </p>

        <p>
          <button type="submit" class="reset-password-btn btn">确认修改</button>
        </p>
      </form>
    </el-dialog>

    <a class="icp-info" href="https://beian.miit.gov.cn" target="_blank">
      <span>沪ICP备20000777号-1</span>
    </a>
  </div>
</template>

<script>
import md5 from 'js-md5';
import { roleMap, passwordSalt } from '@/config';
import { dynamicRoutes } from '@/router/config';
import * as api from '@/api/api.js';
import moment from 'moment';
import { resetRouter } from '@/router';

export default {
  data() {
    return {
      data: {
        body: {
          userName: null,
          password: null,
          confirmpwd: null,
          mobile: null,
          verificationCode: null,
        },
      },
      imgUser: require('@/assets/user.png'),
      imgMobile: require('@/assets/mobile.png'),
      imgPassword: require('@/assets/password.png'),
      imgConfirm: require('@/assets/confirm-password.png'),
      imgCode: require('@/assets/mobile.png'),
      activeTab: 'login',
      warningTab: '',
      // 验证码发送相关状态
      sendCodeDisabled: false,
      sendCodeText: '发送验证码',
      countdown: 0,
      countdownTimer: null,
      pathMap: {
        '0': '/examlist',
        '1': '/tasklist',
        '2': '/tasklist',
        '3': '/tasklist',
        '4': '/tasklist',
        '5': '/tasklist',
        '6': '/model/audit/list',
      },
      // 找回密码相关数据
      resetDialogVisible: false,
      resetData: {
        mobile: '',
        authCode: '',
        password: '',
        confirmPassword: '',
      },
      resetWarningTab: '',
      resetSendCodeDisabled: false,
      resetSendCodeText: '发送验证码',
      resetCountdown: 0,
      resetCountdownTimer: null,
    };
  },
  beforeDestroy() {
    // 组件销毁时清除定时器
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
    if (this.resetCountdownTimer) {
      clearInterval(this.resetCountdownTimer);
    }
  },
  mounted: function() {
    if (window.localStorage.hsJwt) {
      api
        .getUserInfo()
        .then(res => {
          window.localStorage.setItem('hsJwt', res.data.token);
          this.$store.commit({ type: 'setRole', role: roleMap[res.data.user.roleId] });
          this.$store.commit({ type: 'setUserName', userName: res.data.user.userName });
          this.$store.commit({ type: 'setUserId', userId: res.data.user.id });
          resetRouter();
          this.$router.addRoutes(dynamicRoutes[roleMap[res.data.user.roleId] + 'Routes']);
          window.history.length > 2
            ? this.$router.go(-1)
            : this.$router.push({ path: this.pathMap[res.data.user.roleId] });
        })
        .catch(() => {});
    }
  },
  methods: {
    login() {
      this.warningTab = '';
      if (!this.data.body.mobile || !this.data.body.password) return;

      // 验证登录表单
      if (!this.checkLoginInput()) return false;

      api
        .login({
          mobile: this.data.body.mobile,
          password: md5(md5(this.data.body.password) + passwordSalt),
        })
        .then(res => {
          if (res.data.token) {
            window.localStorage.setItem('hsJwt', res.data.token);
            window.localStorage.setItem('code', res.data.code);
            this.$store.commit({ type: 'setRole', role: roleMap[res.data.user.roleId] });
            this.$store.commit({ type: 'setUserName', userName: res.data.user.userName });
            this.$store.commit({ type: 'setUserId', userId: res.data.user.id });
            resetRouter();
            this.$router.addRoutes(dynamicRoutes[roleMap[res.data.user.roleId] + 'Routes']);
            window.history.length > 2
              ? this.$router.go(-1)
              : this.$router.push({ path: this.pathMap[res.data.user.roleId] });
            // 如果是标注员，在进入页面前计算其上月标注准确率，根据准确率判断是否需要练习
            if (res.data.user.roleId === 3) this.caculateLastMonthTaskAccuracy();
          } else {
            this.$notify({
              group: 'foo',
              text: res.message,
              type: 'custom-red',
              duration: 1500,
            });
          }
        })
        .catch(() => {});
    },

    // 验证登录表单
    checkLoginInput() {
      for (let el in this.$refs) {
        if (this.$refs[el]) {
          if (!this.$refs[el].value.match(this.$refs[el].dataset.regex)) {
            this.warningTab = this.$refs[el].dataset.index;
            return false;
          }
        }
      }
      return true;
    },

    signup() {
      this.warningTab = '';
      if (this.data.body.password !== this.data.body.confirmpwd) {
        this.warningTab = '8';
        return;
      }
      if (!this.checkRegisterInput()) return;

      api
        .registerPerson({
          userName: this.data.body.userName,
          mobile: this.data.body.mobile,
          password: md5(md5(this.data.body.password) + passwordSalt),
          authCode: this.data.body.verificationCode,
        })
        .then(() => {
          this.$notify({
            group: 'foo',
            text: '注册成功',
            type: 'custom-blue',
            duration: 1500,
          });
          this.activeTab = 'login';
        })
        .catch(err => {
          // 根据错误类型进行不同处理
          if (err.response && err.response.data) {
            const errorCode = err.response.data.code;
            const errorMessage = err.response.data.message;

            if (errorCode === 'Mobile Registed Error' || errorCode === 'Auth Code Error') {
              this.warningTab = '5';
              this.$notify({
                group: 'foo',
                text: errorMessage,
                type: 'custom-red',
                duration: 1500,
              });
            } else {
              this.$notify({
                group: 'foo',
                text: errorMessage || '注册失败，请重试',
                type: 'custom-red',
                duration: 1500,
              });
            }
          } else {
            this.$notify({
              group: 'foo',
              text: '注册失败，请重试',
              type: 'custom-red',
              duration: 1500,
            });
          }
        });
    },

    // 发送验证码（注册）
    sendVerificationCode() {
      // 先验证手机号格式
      if (!this.data.body.mobile || !this.data.body.mobile.match(/^[1][0-9]{10}$/)) {
        this.warningTab = '4';
        this.$notify({
          group: 'foo',
          text: '请先输入正确的手机号',
          type: 'custom-red',
          duration: 1500,
        });
        return;
      }

      // 发送验证码
      api
        .sendSmsCode({
          mobile: this.data.body.mobile,
          type: 'register',
        })
        .then(res => {
          if (res.data.success) {
            this.$notify({
              group: 'foo',
              text: '验证码发送成功',
              type: 'custom-blue',
              duration: 1500,
            });
            this.startCountdown();
          } else {
            this.$notify({
              group: 'foo',
              text: res.data.message || '验证码发送失败',
              type: 'custom-red',
              duration: 1500,
            });
          }
        });
    },

    // 开始倒计时（注册）
    startCountdown() {
      this.sendCodeDisabled = true;
      this.countdown = 60;
      this.sendCodeText = `${this.countdown}s后重试`;

      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer);
          this.sendCodeDisabled = false;
          this.sendCodeText = '发送验证码';
        } else {
          this.sendCodeText = `${this.countdown}s后重试`;
        }
      }, 1000);
    },

    // 验证注册表单
    checkRegisterInput() {
      const refsToCheck = ['regUserName', 'regMobile', 'regVerificationCode', 'regPwd'];

      for (let refName of refsToCheck) {
        const el = this.$refs[refName];
        if (el && el.dataset && el.dataset.regex) {
          if (!el.value.match(el.dataset.regex)) {
            this.warningTab = el.dataset.index;
            return false;
          }
        }
      }
      return true;
    },

    caculateLastMonthTaskAccuracy() {
      const lastMonthEndTime = moment()
        .startOf('month')
        .unix();
      const lastMonthStartTime = moment()
        .startOf('month')
        .subtract(1, 'month')
        .unix();
      api.getTaskListForSalary().then(res => {
        const taskIds = res.data
          .filter(
            v =>
              moment(new Date(v.updateAt)).unix() >= lastMonthStartTime &&
              moment(new Date(v.updateAt)).unix() < lastMonthEndTime,
          )
          .map(v => v.id);
        if (taskIds.length) {
          api.getStatSalary(taskIds).then(res => {
            const totalAnnoInfo = res.data.reduce(
              (last, cur) => {
                last.correctAnnoCount += cur.correctAnnoCount;
                last.wrongAnnoCount += cur.wrongAnnoCount;
                last.unnecessaryAnnoCount += cur.unnecessaryAnnoCount;
                last.omittedAnnoCount += cur.omittedAnnoCount;
                return last;
              },
              {
                correctAnnoCount: 0,
                wrongAnnoCount: 0,
                unnecessaryAnnoCount: 0,
                omittedAnnoCount: 0,
              },
            );
            if (
              totalAnnoInfo.correctAnnoCount ||
              totalAnnoInfo.wrongAnnoCount ||
              totalAnnoInfo.unnecessaryAnnoCount ||
              totalAnnoInfo.omittedAnnoCount
            )
              window.localStorage.setItem(
                'needPractice',
                totalAnnoInfo.correctAnnoCount /
                  (totalAnnoInfo.correctAnnoCount +
                    totalAnnoInfo.wrongAnnoCount +
                    totalAnnoInfo.unnecessaryAnnoCount +
                    totalAnnoInfo.omittedAnnoCount) >
                  0.7
                  ? '0'
                  : '1',
              );
          });
        }
      });
    },

    // 找回密码相关方法
    showResetDialog() {
      this.resetDialogVisible = true;
    },

    resetDialogClose() {
      // 重置找回密码表单
      this.resetData = {
        mobile: '',
        authCode: '',
        password: '',
        confirmPassword: '',
      };
      this.resetWarningTab = '';
      // 清除倒计时
      if (this.resetCountdownTimer) {
        clearInterval(this.resetCountdownTimer);
        this.resetSendCodeDisabled = false;
        this.resetSendCodeText = '发送验证码';
        this.resetCountdown = 0;
      }
    },

    // 发送验证码（找回密码）
    sendResetVerificationCode() {
      // 先验证手机号格式
      if (!this.resetData.mobile || !this.resetData.mobile.match(/^[1][0-9]{10}$/)) {
        this.resetWarningTab = '1';
        this.$notify({
          group: 'foo',
          text: '请先输入正确的手机号',
          type: 'custom-red',
          duration: 1500,
        });
        return;
      }

      // 发送验证码
      api
        .sendSmsCode({
          mobile: this.resetData.mobile,
          type: 'reset',
        })
        .then(res => {
          if (res.data.success) {
            this.$notify({
              group: 'foo',
              text: '验证码发送成功',
              type: 'custom-blue',
              duration: 1500,
            });
            this.startResetCountdown();
          } else {
            this.$notify({
              group: 'foo',
              text: res.data.message || '验证码发送失败',
              type: 'custom-red',
              duration: 1500,
            });
          }
        })
        .catch(err => {
          const errorMessage = err?.message || '验证码发送失败';
          this.$notify({
            group: 'foo',
            text: errorMessage,
            type: 'custom-red',
            duration: 1500,
          });
        });
    },

    // 开始倒计时（找回密码）
    startResetCountdown() {
      this.resetSendCodeDisabled = true;
      this.resetCountdown = 60;
      this.resetSendCodeText = `${this.resetCountdown}s后重试`;

      this.resetCountdownTimer = setInterval(() => {
        this.resetCountdown--;
        if (this.resetCountdown <= 0) {
          clearInterval(this.resetCountdownTimer);
          this.resetSendCodeDisabled = false;
          this.resetSendCodeText = '发送验证码';
        } else {
          this.resetSendCodeText = `${this.resetCountdown}s后重试`;
        }
      }, 1000);
    },

    // 验证找回密码表单
    checkResetInput() {
      // 验证手机号
      if (!this.resetData.mobile.match(/^[1][0-9]{10}$/)) {
        this.resetWarningTab = '1';
        return false;
      }
      // 验证验证码
      if (!this.resetData.authCode.match(/^[0-9]{6}$/)) {
        this.resetWarningTab = '2';
        return false;
      }
      // 验证密码
      if (!this.resetData.password.match(/^[0-9a-zA-Z]{6,20}$/)) {
        this.resetWarningTab = '3';
        return false;
      }
      // 验证确认密码
      if (this.resetData.password !== this.resetData.confirmPassword) {
        this.resetWarningTab = '4';
        return false;
      }
      return true;
    },

    // 提交找回密码
    submitResetPassword() {
      this.resetWarningTab = '';

      if (!this.checkResetInput()) {
        return;
      }

      api
        .resetPassword({
          mobile: this.resetData.mobile,
          password: md5(md5(this.resetData.password) + passwordSalt),
          authCode: this.resetData.authCode,
        })
        .then(res => {
          if (res.data.success) {
            this.$notify({
              group: 'foo',
              text: '密码重置成功，请使用新密码登录',
              type: 'custom-blue',
              duration: 2000,
            });
            this.resetDialogVisible = false;
            // 切换到登录tab
            this.activeTab = 'login';
          }
        })
        .catch(() => {
          this.$notify({
            group: 'foo',
            text: '密码重置失败，请重试',
            type: 'custom-red',
            duration: 1500,
          });
        });
    },
  },
};
</script>
<style scoped>
li {
  font-size: 18px;
  cursor: pointer;
}
button {
  height: 38px;
  width: 304px;
  border-radius: 4px;
  margin: 28px auto 0;
}
input {
  font-size: 14px;
  height: 38px;
  width: 304px;
  padding: 12px 12px 12px 32px;
  margin: 8px auto 16px;
  border-radius: 4px;
  border: 1px solid #dddddd;
  box-sizing: border-box;
  background-repeat: no-repeat;
  background-position: 13px;
  background-size: 14px;
}
p {
  margin: 0;
  position: relative;
}
p span {
  font-size: 12px;
  line-height: 12px;
  color: red;
  display: block;
  padding: 0 68px;
  margin: auto;
  text-align: left;
}

/* 找回密码链接样式 */
.forgot-password {
  position: absolute;
  z-index: 2;
  right: 36px;
  bottom: -10px;
  font-size: 12px;
  color: #5d89c0;
  cursor: pointer;
  padding: 0;
  margin: 0;
  display: inline-block;
  width: auto;
  text-align: right;
}

.forgot-password:hover {
  color: #4a6fa0;
  text-decoration: underline;
}

.forgot-password:active {
  color: #3a5880;
}

/* 验证码容器样式 */
.verification-code-container {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin: 0 auto;
  width: 304px;
}

/* 验证码输入框样式 */
.verification-code-input {
  width: 200px;
  margin-right: 8px;
  margin-bottom: 16px;
}

/* 发送验证码按钮样式 */
.send-code-btn {
  height: 38px;
  width: 96px;
  margin: 8px 0 16px 0;
  font-size: 12px;
  flex-shrink: 0;
}

/* 验证码错误提示样式 */
.verification-code-warning {
  position: absolute;
  top: 54px;
  left: 0;
  width: 100%;
  font-size: 12px;
  line-height: 12px;
  color: red;
  text-align: left;
  padding: 0 0;
  margin: 0;
}

/* 对话框内按钮样式 */
.reset-password-btn {
  background-color: #5d89c0;
  color: white;
  border: none;
  cursor: pointer;
}

.reset-password-btn:hover {
  background-color: #4a6fa0;
}

.reset-password-btn:active {
  background-color: #3a5880;
}

.login-title img {
  width: 27px;
  height: 30px;
}
.login-container {
  text-align: center;
  padding: 0;
  position: absolute;
  min-height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: #f5f5f5;
}
.login-form {
  box-sizing: border-box;
  margin: 160px auto 63px;
  padding: 0 0 50px;
  width: 376px;
  border-radius: 8px;
  background-color: #ffffff;
}
.login-title {
  padding: 50px 0;
  font-size: 24px;
  color: #12335e;
}
.login-title img {
  display: inline-block;
  margin: auto 4px;
  vertical-align: middle;
}
.login-title span {
  display: inline-block;
  margin: auto 4px;
  vertical-align: middle;
}
.login-tab {
  list-style: none;
  margin: 0 0 24px;
  padding: 0;
}
.login-tab li {
  line-height: 100%;
  display: inline-block;
  margin: 0 20px;
  height: 100%;
  padding: 0 42px 12px;
}
.login-tab .active {
  color: #5d89c0;
  border-bottom: 2px solid #5d89c0;
}
.warning {
  border: 2px solid red;
  margin-bottom: 4px;
}
.icp-info {
  display: block;
  position: absolute;
  bottom: 0;
  width: 100%;
  min-width: 1440px;
}
</style>
